import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4562d302"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-select" }
const _hoisted_2 = { class: "box__content" }
const _hoisted_3 = { class: "box__selected-item-title" }
const _hoisted_4 = { class: "box__notched notched-outline" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notched-outline__leading notched-outline--endings" }, null, -1))
const _hoisted_6 = { class: "notched-outline__notch" }
const _hoisted_7 = { class: "notched-outline__label" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notched-outline__trailing notched-outline--endings" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "list-select__menu-container"
}
const _hoisted_10 = { class: "list-select__menu" }

import ListSelectMenuItem from './list-select-menu-item.vue';
import { IListSelectProps } from './list-select.types';
import { reactive } from 'vue';
import GoogleMaterialIcon from '../../helper-components/google-material-icon/google-material-icon.vue';

type IListSelectEmits = {
    (event: 'selected', itemId: number | null): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'list-select',
  props: {
    props: null
  },
  emits: ["selected"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'selected', itemId: number | null): void;
}), expose: any, slots: any, attrs: any }) {





const state = reactive({
    isExpanded: false,
});

let onBoxClicked = () => {
    state.isExpanded = !state.isExpanded;
};

let onSelection = (itemId: number | null) => {
    emit('selected', itemId);
    onBoxClicked();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "list-select__box-container box",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onBoxClicked) && _unref(onBoxClicked)(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.props.selectedItemId
                            ? __props.props.menuItems.find(
                                  (i) => i.id == __props.props.selectedItemId
                              )?.title
                            : __props.props.defaultSelectionTitle), 1),
        _createVNode(GoogleMaterialIcon, {
          props: {
                        iconName: state.isExpanded
                            ? 'arrow_drop_up'
                            : 'arrow_drop_down',
                    }
        }, null, 8, ["props"])
      ]),
      _createElementVNode("span", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(__props.props.title), 1)
        ]),
        _hoisted_8
      ])
    ]),
    (state.isExpanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("ul", _hoisted_10, [
            (__props.props.isDefaultSelectionAvaliable)
              ? (_openBlock(), _createBlock(ListSelectMenuItem, {
                  key: -1,
                  props: {
                        id: -1,
                        title: __props.props.defaultSelectionTitle,
                        isSelected: __props.props.selectedItemId == null,
                    },
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(onSelection)(null)))
                }, null, 8, ["props"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.props.menuItems, (item) => {
              return (_openBlock(), _createBlock(ListSelectMenuItem, {
                key: item.id,
                props: {
                        id: item.id,
                        title: item.title,
                        isSelected: item.id == __props.props.selectedItemId,
                    },
                onClick: ($event: any) => (_unref(onSelection)(item.id))
              }, null, 8, ["props", "onClick"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})